import Image = Occ.Image
import { Injectable } from '@angular/core'
import { Config, Occ } from '@spartacus/core'
import { Media, MediaContainer, MediaService, MediaFormatSize } from '@spartacus/storefront'
import { EbPicture, EbPictureSource, leftMediaConfig, MediaFormat, rightMediaConfig } from './eb-media.interface'

@Injectable()
export class EbMediaService extends MediaService {
  private static populateMediaQuery(
    source: EbPictureSource,
    index: number,
    picture: EbPicture
  ): void {
    if (index === 0) {
      source.minWidth = 0
    } else {
      source.query.push(`(min-width: ${source.minWidth}px)`)
    }
    if (index < picture.length - 1) {
      source.maxWidth = picture[index + 1].minWidth - 1
      source.query.push(`(max-width: ${source.maxWidth}px)`)
    }
  }
  getPictureByContainer(container: MediaContainer, alignTextLeft?: string): EbPicture {
    return this.createPicture(this.getFormatsHavingMedia(container, alignTextLeft), container)
  }

  private getFormatsHavingMedia(container: MediaContainer, alignTextLeft?: string) {
    if(alignTextLeft === 'true') {
      return this.sortMediaFormats(leftMediaConfig)
    }
    if(alignTextLeft === 'false') {
      return this.sortMediaFormats(rightMediaConfig)
    }
    return this.sortedFormats.filter(format => format?.size?.width && !!container?.[format.code])
  }

  private createPicture(formats: MediaFormat[], container: MediaContainer): EbPicture {
    const picture = formats.map(format => this.createSingleSource(format, container[format.code]))
    picture.forEach(EbMediaService.populateMediaQuery)
    return picture
  }

  private createSingleSource(format: MediaFormat, image: Image): EbPictureSource {
    return {
      minWidth: format.size.width,
      media: this.createMediaFromImage(image),
      query: []
    } as EbPictureSource
  }

  private createMediaFromImage(image: Image): Media {
    if(image !== undefined) {
      return {
        src: this.resolveAbsoluteUrl(image.url)
      }
    }
  }

  private sortMediaFormats(config: Config): { code: string; size: MediaFormatSize }[] {
      return Object.keys(config.mediaFormats)
      .map((key) => ({
        code: key,
        size: config.mediaFormats[key],
      }))
      .sort((a, b) =>
        a.size.width && b.size.width && a.size.width > b.size.width ? 1 : -1
      ) ?? [];
    }
}
